import React, { useContext, Fragment, useEffect, useRef, useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import PageScrollContext from 'context/PageScrollContext';
import md5 from 'crypto-js/md5';
import {
    Page,
    Range,
    ColorPicker,
    FormGroup,
    Input,
    Textarea,
    FormControl,
    Dropdown,
    Switch,
    CustomText,
    Icon,
    Button,
    Alert,
    VideoModal,
    RichEditor,
    ButtonSelect,
    MultiCurrencyModeAlerts
} from 'components';
import PreviewContext from 'context/PreviewContext';
import ShopContext from 'context/ShopContext';
import UserContext from 'context/UserContext';
import { GOOGLE_FONTS, CAMPAIGN_TYPES, SHOP_DEFAULT_SETTINGS, BREAK_POINTS } from 'lib/globals';
import { SAVE_SHOP_SETTINGS, UPDATE_SHOP_PROP } from 'lib/mutations';
import CheckoutButton from 'screens/campaigns/settings/ExtraModules/CheckoutButton';
import { Loading, Toast, Modal } from '@shopify/app-bridge-react';

import { ShopConstraints } from 'Constraints';
import removeTypeName, { removeByType } from 'lib/removeTypeName';
import { Run } from 'lib/validate';
import { GET_SHOP_SETTINGS } from 'Queries';
import { API, graphqlOperation } from 'aws-amplify';
import { APP_DEV } from 'aws-exports';
import Axios from 'axios';
import { useTransition } from 'react-spring';
import _ from 'lodash';
import classNames from 'lib/classNames';
import useReactRouter from 'use-react-router';
import { SET_ALL } from 'reducers/SetItemReducer';
import useRefState from 'hooks/useRefState';
import { ScarcitySettings } from './settings/scarcity';
import { BadgesSettings } from './settings/badges';
import { TermsSettings } from './settings/terms';
import AnnouncementSettings from './settings/announcement';
import StaticFileIntegration from './settings/StaticFileIntegration';
import { getSessionToken } from '@shopify/app-bridge-utils';
import EmbeddedContext from 'context/EmbeddedContext';
import { trackMixPanelEvent } from 'lib/mixpanel';
import { Redirect } from '@shopify/app-bridge/actions';

const CartScreen = (props) => {
    const {
        setCartIsEmpty,
        setAutoDiscount,
        setCheckoutButtonLoadingEdit,
        campaign_preview_types
    } = useContext(PreviewContext);
    const stickyAlert = useRef(null);
    const { history, location } = useReactRouter();
    const [scrollTop, setScrollTop, scrollTopRef] = useRefState();
    const [cartActivateLoading, setCartActivateLoading] = useState(false);
    const [videoOne, setVideoOne] = useState(false);
    const [googleFonts, setGoogleFonts] = useState([]);
    const [hideTopBar, setHideTopBar] = useState(false);
    const [embedInstructionsCollapsed, setEmbedInstructionsCollapsed] = useState(false);
    const [showConfirmActivate, setShowConfirmActivate] = useState(false);
    const [showInstallationModel, setShowInstallationModel] = useState(false);
    const [campaign_preview_visible, setCampaign_preview_visible] = useState(false);
    const campaign_preview_content_ref = useRef(null);
    const shopContext = useContext(ShopContext);
    const { app, AppBridgeRedirect } = useContext(EmbeddedContext);
    const user = useContext(UserContext);
    const {
        state,
        discard,
        validationErrors,
        setValidationErrors,
        dispatch,
        setItem,
        AppLocalStorage
    } = shopContext;
    const {
        campaigns,
        draft_checkout_alerted,
        multi_currency_checkout_alerted,
        static_file_eligible
    } = state;
    // const filterSettings = (settings) =>
    // 	_.merge(
    // 		{},
    // 		SHOP_DEFAULT_SETTINGS(),
    // 		removeByType(
    // 			removeTypeName(
    // 				Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
    // 			),
    // 			(v) => v !== '' && v !== null
    // 		)
    // 	);
    const filterSettings = (settings) => {
        return removeByType(
            removeTypeName(
                Object.fromEntries(
                    Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key))
                )
            ),
            (v) => v !== '' && v !== null
        );

        return (
            _.mergeWith(
                SHOP_DEFAULT_SETTINGS(),
                removeByType(
                    removeTypeName(
                        Object.fromEntries(
                            Object.entries(settings).filter(
                                ([key]) => !['settingsSaved'].includes(key)
                            )
                        )
                    ),
                    (v) => v !== '' && v !== null
                ),
                (v) => v !== '' && v !== null
            ),
            (objValue, srcValue) => (srcValue && _.isArray(srcValue) ? srcValue : undefined)
        );
    };

    let [saveShopSettings, { data, error, loading }] = useMutation(SAVE_SHOP_SETTINGS, {
        refetchQueries: [
            {
                query: GET_SHOP_SETTINGS,
                variables: {
                    userId: user.attributes.website
                }
            }
        ]
    });
    const transitions = useTransition(
        !_.isEqual(state.original_settings, state.settings) && !hideTopBar,
        null,
        {
            from: { position: 'absolute', opacity: 0 },
            enter: { opacity: 1 },
            leave: { opacity: 0 },
            config: {
                duration: 300
            }
        }
    );
    const validate = (state, specific = []) =>
        Run(state, specific, {
            errors: validationErrors,
            setErrors: setValidationErrors,
            constraints: ShopConstraints
        });
    const save = (assign = {}, checkRTL = true) => {
        if (validate(state)) return;
        // if (
        //   checkRTL &&
        //   Object.keys(state.original_settings || {}).length &&
        //   state.settings.rtl !== state.original_settings.rtl
        // ) {
        //   return activateCart(state.settings.active, true, state.settings.rtl);
        // }

        if (!AppLocalStorage.getItem('first_cart_turn_on'))
            AppLocalStorage.setItem('first_cart_turn_on', true);

        saveShopSettings({
            variables: {
                id: user.attributes.website,
                input: filterSettings(Object.assign(state.settings, assign))
            }
        });
    };

    const activateCart = async (active, confirmed = false, rtl = null, disableLoading = true) => {
        if (
            active &&
            !confirmed &&
            !state.settingsSaved &&
            _.isEqual(SHOP_DEFAULT_SETTINGS, state.settings)
        ) {
            return setShowConfirmActivate(true);
        }
        setCartActivateLoading(true);
        const { success } = await API.post('API_GATEWAY_NEW', '/cart/activate', {
            body: { active, rtl: rtl === null ? state.settings.rtl : rtl }
        });
        if (disableLoading) setCartActivateLoading(false);

        if (!AppLocalStorage.getItem('first_cart_turn_on')) {
            AppLocalStorage.setItem('first_cart_turn_on', true);
            trackMixPanelEvent('First cart turn ON', state?.id);
        }
        return save({ active }, false);
    };

    const handleOutSideClick = (event) => {
        if (!campaign_preview_content_ref.current) return;
        else if (campaign_preview_content_ref.current.contains(event.target)) return;
        setCampaign_preview_visible(false);
    };

    const toggle_type = (type, value) => {
        if (value) {
            campaign_preview_types.set([...new Set(campaign_preview_types.get.concat([type]))]);
        } else {
            campaign_preview_types.set(campaign_preview_types.get.filter((c) => c !== type));
        }
    };

    const type_is_active = (type) => {
        const typeIndex = campaign_preview_types.get.indexOf(type);
        return typeIndex !== -1 ? true : false;
    };

    useEffect(() => {
        if (campaign_preview_visible)
            document.addEventListener('mousedown', handleOutSideClick, false);
        else document.removeEventListener('mousedown', handleOutSideClick, false);
        return () => {
            document.removeEventListener('mousedown', handleOutSideClick, false);
        };
    }, [campaign_preview_visible]);

    useEffect(() => {
        // if (typeof state.settings.multiCurrencyMode !== 'boolean') {
        // 	setItem('settings.multiCurrencyMode', false);
        // }
        async function getGoogleFonts() {
            const { data } = await Axios.get(
                `https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyCYLq50twmAe1_7jITZuehrERZWOjNqBCY`
            );
            setGoogleFonts(
                data.items.map(({ family, variants }) => ({
                    label: family,
                    value: `${family}:${variants.join()}`
                }))
            );
        }
        getGoogleFonts();
    }, []);

    const redirectToCheckoutSettings = (e) => {
        e.preventDefault();
        if (!scrollTopRef.current) return;
        const padding = 1.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        scrollTopRef.current(
            document.getElementById(`id_${md5('checkout settings')}`).closest('.mu-group-wrapper')
                .offsetTop - 0
        );
    };

    const updateShopProps = async (input) => {
        const authToken = `Bearer ${await getSessionToken(app)}`;
        await API.graphql(
            graphqlOperation(
                UPDATE_SHOP_PROP,
                {
                    id: user.attributes.website,
                    input
                },
                authToken
            )
        );
        Object.entries(input).forEach(([key, value]) => {
            setItem(key, value);
        });
    };

    useEffect(() => {
        setHideTopBar(!!data);
        if (APP_DEV) {
            const timeout = setTimeout(() => setHideTopBar(false), 1500);
            return () => clearTimeout(timeout);
        }
    }, [data]);

    useEffect(() => {
        if (state.settings.cod_settings.checkout_mode == 'cod_and_checkout') {
            setItem('settings.cod_settings.is_form_in_cart', false);
        }
    }, [state.settings.cod_settings]);

    return (
        <Page
            background="none"
            getScrollTop={({ scrollTop }) => {
                setScrollTop(scrollTop);
            }}
            padding={0}
            header={{
                title: 'Settings'
            }}
            TopContent={{
                transitions,
                render: () => (
                    <Alert
                        type="save_settings"
                        title="unsaved changes"
                        borderPosition="none"
                        paddingX="px-6"
                        actions={[
                            {
                                text: 'Discard',
                                type: 'secondary',
                                loading: false,
                                onClick: () => discard()
                            },
                            {
                                text: 'Save',
                                type: 'primary',
                                loading: loading || cartActivateLoading,
                                onClick: () => save()
                            }
                        ]}
                    />
                )
            }}
        >
            <Fragment>
                {data && (
                    <Toast
                        content="Cart settings has been saved"
                        duration={3000}
                        onDismiss={() => {
                            setHideTopBar(false);
                        }}
                    />
                )}
                {(loading || cartActivateLoading) && <Loading />}
                {/* <div className={classNames("bg-white rounded overflow-hidden shadow mb-10")}>
          <div className={classNames("flex-center border-b px-3 py-1 text-gray-600")}>
            <b className={classNames("flex-1 font-semibold text-base uppercase-first")}>Activation instructions</b>
            <button className={classNames("w-10 h-10 flex-center hover:bg-gray-200 rounded-full focus:outline-none")} onClick={() => setEmbedInstructionsCollapsed(!embedInstructionsCollapsed)}>
              <Icon icon="angle-up" style={{
                transform: embedInstructionsCollapsed ? "rotate(180deg)" : undefined
              }}
              />
            </button>
          </div>
          <div className={classNames("text-gray-600 text-sm")} style={{
            height: embedInstructionsCollapsed ? 0 : undefined
          }}>
            <div className={classNames("p-3")}>
              <div className={classNames("leading-loose mb-3")}>
                <p>When you click "Preview in theme" you will be redirected to your Shopify theme editor where you can turn your cart ON and OFF.</p>
                <p>All you need to do is enable/disable MonsterUpsells and click save.</p>
              </div>
              <img className={classNames("border rounded")} src={`${window.location.origin}/static/images/embed-screenshot.jpg`} />
              <div className={classNames("flex flex-row-reverse mt-3")}>
                <Button type="primary" text="Preview in theme" className={classNames("ml-3")} />
                <Button type="secondary" text="Watch video tutorial" />
              </div>
            </div>
          </div>
        </div> */}
                <Alert
                    type="info"
                    title="MonsterUpsells Cart Status"
                    className="z-5"
                    actions={[
                        {
                            text: 'Enable / Disable MonsterUpsells',
                            type: 'primary',
                            loading: cartActivateLoading,
                            onClick: async () => {
                                if (!state.settingsSaved) {
                                    await save();
                                }
                                setShowInstallationModel(true);
                            }
                        }
                    ]}
                >
                    <p>
                        Once you are happy with how your cart looks activate it in your theme
                        editor.
                    </p>
                </Alert>
                <Modal
                    size="Large"
                    title="Installation"
                    open={!!showInstallationModel}
                    primaryAction={{
                        content: 'Open Editor',
                        onAction: function () {
                            const activateAppId = APP_DEV
                                ? '13fae760-4743-463c-aaeb-80cebaccc364'
                                : 'a1b8e58a-bf1d-4e0f-8768-a387c3f643c0';
                            const deepLink = `/themes/current/editor?context=apps&template=product&activateAppId=${activateAppId}/app-embed`;
                            AppBridgeRedirect.dispatch(Redirect.Action.ADMIN_PATH, {
                                path: deepLink,
                                newContext: true
                            });
                        }
                    }}
                    secondaryActions={[
                        {
                            content: 'Watch Tutorial',
                            onAction: () => {
                                AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, {
                                    url: 'https://monsterapps.crisp.help/en/article/activate-deactivate-monster-cart-19okfn1/',
                                    newContext: true
                                });
                            }
                        }
                    ]}
                    src={`${window.location.origin}/AppThemeExtensionInstallation.html`}
                    onClose={() => setShowInstallationModel(false)}
                />
                <Alert
                    {...{
                        forwardRef: stickyAlert,
                        type: state.settings.active ? 'success' : 'warning',
                        title: `custom cart is ${state.settings.active ? 'enabled' : 'disabled'}`,
                        withSwitch: {
                            context: [
                                shopContext,
                                'settings.active',
                                (value) => activateCart(value)
                            ]
                        },
                        icon: state.settings.active ? 'check-circle' : 'exclamation-circle'
                    }}
                    className="z-5 hidden"
                >
                    {state.settings.active && (
                        <p>
                            Cart button not working? Click to{' '}
                            <span
                                href="#"
                                className={classNames('font-bold underline cursor-pointer')}
                                onClick={() => {
                                    history.push('/settings/setup' + location.search);
                                }}
                            >
                                manually setup
                            </span>
                        </p>
                    )}
                    {!state.settings.active && (
                        <p>Customize default cart settings / visuals and set it live.</p>
                    )}
                </Alert>
                {static_file_eligible && <StaticFileIntegration setItem={setItem} />}
                {campaigns.length === 0 && (
                    <Alert
                        {...{
                            type: 'warning',
                            borderPosition: 'border-l-4',
                            iconSize: '2x',
                            title: 'Create your first campaign',
                            icon: 'exclamation-circle',
                            customStyle: {
                                icon: 'text-orange-400 self-start mt-1'
                            }
                        }}
                        className="my-6 z-5"
                    >
                        <p>Visit Campaign Page To Create Your 1st Upsell Campaign.</p>
                        <div className={classNames('flex space-x-3 pt-3 justify-start')}>
                            <a
                                className={classNames(
                                    'text-gray-800 text-sm flex items-center hover:text-orange-500 focus:outline-none focus:outline-shadow font-semibold py-1 px-2 uppercase border bg-orange-200 bg-opacity-50 border-orange-300 rounded'
                                )}
                                onClick={() => history.push('campaigns/create' + location.search)}
                            >
                                <Icon icon="info-circle" className="mr-2" size="1x" />
                                <span className={classNames('text-xs')}>Create campaign</span>
                            </a>
                        </div>
                    </Alert>
                )}

                <Modal
                    title="Activating custom cart"
                    message="You're about to activate the cart with the default settings"
                    open={!!showConfirmActivate}
                    primaryAction={{
                        content: 'Activate',
                        destructive: true,
                        onAction: () => {
                            setShowConfirmActivate(false);
                            activateCart(true, true);
                        }
                    }}
                    secondaryActions={[
                        {
                            content: 'Cancel',
                            onAction: () => {
                                setShowConfirmActivate(false);
                                discard();
                            }
                        }
                    ]}
                />
                <MultiCurrencyModeAlerts
                    {...{ ...state, redirectToCheckoutSettings, IUnderstand: updateShopProps }}
                />

                <FormGroup label="theme settings" info="Customize the main cart settings">
                    <FormControl label="Default language">
                        <Dropdown
                            options={[
                                { value: 'english', label: 'English' },
                                { value: 'french', label: 'Français' },
                                { value: 'german', label: 'German' },
                                { value: 'arabic', label: 'العربية' }
                            ]}
                            first
                            autoFocus={true}
                            BindToContext={[
                                shopContext,
                                'settings.default_language',
                                (language) => {
                                    dispatch({
                                        type: SET_ALL,
                                        value: {
                                            ...state,
                                            settings: SHOP_DEFAULT_SETTINGS(language)
                                        }
                                    });
                                },
                                'settings'
                            ]}
                        />
                    </FormControl>
                    <FormControl
                        label="Colors"
                        error={validationErrors['settings.theme.background']}
                    >
                        <ColorPicker
                            text="background"
                            BindToContext={[shopContext, 'settings.theme.background']}
                        />
                    </FormControl>
                    <FormControl
                        label="default font size"
                        info="This font effects all other cart font sizes"
                        error={validationErrors['settings.font.size']}
                    >
                        <Input
                            type="number"
                            icon={{ char: 'PX' }}
                            max={18}
                            min={12}
                            BindToContext={[shopContext, 'settings.font.size']}
                            hasError={!!validationErrors['settings.font.size']}
                        />
                    </FormControl>
                    <FormControl
                        label="font family"
                        withSwitch={[shopContext, 'settings.font.custom']}
                        info="By default the cart will use your store theme font. Turn this section on to add a custom google font."
                    >
                        <Dropdown
                            disabled={!state.settings.font.custom || !googleFonts.length}
                            options={googleFonts}
                            first
                            BindToContext={[shopContext, 'settings.font.family']}
                        />
                    </FormControl>
                    <FormControl
                        label="display cart on RTL"
                        withSwitch={[shopContext, 'settings.rtl']}
                        info="Enable this if your store language uses right to left scripts."
                    />
                    <FormControl
                        label="Curve corners"
                        withSwitch={[shopContext, 'settings.curved']}
                        info="Turn curved corners on and off."
                    />
                    <FormControl
                        label="Display compare price"
                        info="Show Shopify product compare pricing in cart."
                        withSwitch={[shopContext, 'settings.count_compare_at']}
                    />
                </FormGroup>
                <FormGroup label="header settings">
                    <CustomText
                        context={shopContext}
                        label="cart title"
                        path="settings.header.title"
                        hasWeight="700"
                        // info="The em unit is relative to the font size (2em means 2 times the current font size)"
                    />
                    <FormControl
                        label="header colors"
                        error={validationErrors['settings.header.background']}
                    >
                        <ColorPicker
                            text="text"
                            BindToContext={[shopContext, 'settings.header.title.color']}
                        />
                        <ColorPicker
                            text="background"
                            BindToContext={[shopContext, 'settings.header.background']}
                        />
                    </FormControl>
                </FormGroup>
                <FormGroup label="cart setup" info="Design the basic cart visuals">
                    <CustomText
                        context={shopContext}
                        label="product title"
                        path="settings.product.title"
                        hasColor={true}
                        hasWeight="700"
                    />
                    <CustomText
                        context={shopContext}
                        label="product price"
                        path="settings.product.price"
                        hasColor={true}
                        hasWeight="700"
                    />
                    <FormControl
                        label="product image size"
                        info="an integer between 50 and 120"
                        error={validationErrors['settings.product.image_size']}
                    >
                        <Input
                            type="number"
                            BindToContext={[shopContext, 'settings.product.image_size']}
                            min={50}
                            max={120}
                        />
                    </FormControl>
                    <FormControl
                        label="lower checkout button"
                        info="Checkout button will sit at the bottom of screen unless products push it lower."
                        error={validationErrors['settings.product.grow']}
                    >
                        <Switch BindToContext={[shopContext, 'settings.product.grow']} />
                    </FormControl>
                    <FormControl
                        label="Add to cart opens Cart"
                        info="Every time a customer adds to cart the slide cart will appears. (We recommended leaving this on.)"
                        error={validationErrors['settings.open_cart']}
                    >
                        <Switch BindToContext={[shopContext, 'settings.open_cart']} />
                    </FormControl>
                    <FormControl
                        label="sold out"
                        error={validationErrors['settings.product.sold_out']}
                    >
                        <Input
                            type="text"
                            BindToContext={[
                                shopContext,
                                'settings.product.sold_out',
                                null,
                                'settings'
                            ]}
                            hasError={!!validationErrors['settings.product.sold_out']}
                        />
                    </FormControl>
                    <FormControl
                        label="empty cart"
                        info={`Displayed when no products are in the cart.
							Tip: you can add images`}
                    >
                        <RichEditor
                            placeholder="empty cart text"
                            BindToContext={[shopContext, 'settings.empty_cart']}
                            onFocus={() => {
                                setCartIsEmpty(true);
                            }}
                            onBlur={(editor, activeElement) => {
                                if (!editor.contains(activeElement)) setCartIsEmpty(false);
                            }}
                        />
                    </FormControl>
                    <FormControl
                        label="Empty cart - Continue shopping button"
                        info="Make it easy for customers to continue shopping"
                        withSwitch={[shopContext, 'settings.active_continue_shopping_button']}
                    >
                        {state.settings.active_continue_shopping_button && (
                            <CustomText
                                context={shopContext}
                                placeholder="Continue shopping"
                                hasColor={true}
                                path="settings.continue_shopping_button"
                                onFocus={() => {
                                    setCartIsEmpty(true);
                                }}
                                onBlur={() => {
                                    setCartIsEmpty(false);
                                }}
                                hasWeight={true}
                            />
                        )}
                    </FormControl>
                </FormGroup>

                <FormGroup
                    label="Auto discount style"
                    onFocus={() => setAutoDiscount(true)}
                    onBlur={() => setAutoDiscount(false)}
                >
                    <CustomText
                        context={shopContext}
                        label="text"
                        path="settings.auto_discount.text"
                        hasColor={true}
                        hasWeight="700"
                        beta
                    />
                    <FormControl>
                        <ColorPicker
                            text="Background"
                            BindToContext={[shopContext, 'settings.auto_discount.background']}
                        />
                        <ColorPicker
                            text="Border"
                            BindToContext={[shopContext, 'settings.auto_discount.border']}
                        />
                    </FormControl>
                </FormGroup>
                <CheckoutButton
                    context={shopContext}
                    setCheckoutButtonLoadingEdit={setCheckoutButtonLoadingEdit}
                />

                <ScarcitySettings {...{ shopContext }} />
                <BadgesSettings {...{ shopContext }} />
                <TermsSettings {...{ shopContext }} />
                <AnnouncementSettings {...{ shopContext }} />
                <FormGroup label="Custom CSS">
                    <FormControl
                        label="Manually Add Custom CSS Changes To The Cart."
                        info={`This is helpful if you need to modify text sizes and introduce small branding elements.
							Reach out to the team if you need help finding specific id's. Styles will only be applied to live cart on your store not in dashboard preview. 
							(Advanced users only)`}
                    >
                        <Textarea
                            BindToContext={[shopContext, 'settings.custom_css']}
                            placeholder=".text{ color: blue; }"
                        />
                    </FormControl>
                </FormGroup>

                {!BREAK_POINTS['kill_draft'](shopContext) && (
                    <FormGroup
                        label="checkout settings"
                        info={`
						<p class="${classNames(
                            'mb-1'
                        )}">To navigate Shopify’s limited discount functionalities we use draft discounts.</p>
						<h4 class="${classNames('font-bold text-gray-600 mb-1')}">Draft checkout:</h4>
						<p>has more discount functionality and is preferred option for upsells.</p>
						<h4 class="${classNames('font-bold text-gray-600 mb-1')}">Normal Shopify checkout:</h4>
						<p>works better for stores that sell in multi-currency and want customers to add discounts in checkout area.</p>
						`}
                    >
                        <ButtonSelect
                            isVertical
                            options={[
                                {
                                    label: 'Draft Checkout',
                                    value: false,
                                    infoHtml: true,
                                    info: `
								<ul class="${classNames('list-disc list-inside')}">
									<li>Allow multiple discounts</li>
									<li>More powerful campaign options</li>
									<li>Checkout is in default store currency</li>
									<li>Coupon must be added in upsell cart</li>
								</ul>
								`
                                },
                                {
                                    label: 'Normal Shopify Checkout',
                                    value: true,
                                    infoHtml: true,
                                    info: `
									<ul class="${classNames('list-disc list-inside')}">
									<li>One discount at a time</li>
									<li>Uses unique discount codes injected at checkout</li>
									<li>Checkout is in Multi-currency</li>
									<li>Coupons added in checkout like normal</li>
								</ul>
								`
                                }
                            ]}
                            BindToContext={[shopContext, 'settings.multiCurrencyMode']}
                        />
                    </FormGroup>
                )}

                {/* // COD */}
                <FormGroup
                    label="Cash On Delivery Checkout"
                    info={`<p>Replace standard Shopify checkout process with our fully customizable COD checkout.</p>`}
                >
                    <ButtonSelect
                        isVertical
                        options={[
                            {
                                label: 'Cash On Delivery Checkout - COD ( Shopify will not take any payments)',
                                infoHtml: true,
                                withSwitch: true,
                                disabledClick: true,
                                info: `
								<ul class="${classNames('list-disc list-inside')}">
									<li>Replace checkout with quick order form</li>
									<li>Creates Draft order for you to fullfill </li>
									<li>Skips all checkout payment options (example: Paypal, Shopify Payments, Afterpay)</li>
									<li>Creates customer orders/accounts for you to fullfill and collect payment for</li>
								</ul>
								`
                            }
                        ]}
                        BindToContext={[shopContext, 'settings.cod_settings.is_active']}
                        showCheckedIcon={false}
                    />
                    {state.settings.cod_settings.is_active && (
                        <>
                            <FormControl
                                label="Cash on delivery options"
                                info="Would you like to give both checkout options or limit to just cash on delivery?"
                                error={validationErrors['settings.cod_settings.checkout_mode']}
                                isSingleCol={true}
                            >
                                <ButtonSelect
                                    options={[
                                        { label: 'Cash on Delivery only', value: 'cod_only' },
                                        {
                                            label: 'Checkout and cash on delivery',
                                            value: 'cod_and_checkout'
                                        }
                                    ]}
                                    BindToContext={[
                                        shopContext,
                                        'settings.cod_settings.checkout_mode'
                                    ]}
                                />
                            </FormControl>
                            <FormControl>
                                <div>
                                    <Button
                                        text="Customize COD Checkout"
                                        onClick={() => {
                                            history.push('/settings/checkout' + location.search);
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </FormControl>
                        </>
                    )}
                    {state.settings.cod_settings.checkout_mode == 'cod_only' && (
                        <FormControl
                            label="one step checkout"
                            withSwitch={[shopContext, 'settings.cod_settings.is_form_in_cart']}
                            info="Display the checkout form in the main cart for a fast onr step checkout."
                        />
                    )}
                </FormGroup>
            </Fragment>
        </Page>
    );
};

export default CartScreen;
